// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentNote_root_2_AG8","header":"PaymentNote_header_XHLvX","body":"PaymentNote_body_3cC7b"};